import React, { useMemo } from 'react';
import { useI18n } from '../../contexts/I18nContext';
import { fmtInTz, zonedParts } from '../../lib/tz';
import { MV, HATCH, segmentsBetween } from '../../lib/movementView';

const FILL = { moving: MV.moving.bar, rest: MV.rest.bar };
const LABEL = { moving: 'mvd_moving', rest: 'mvd_resting', gap: 'mvd_nosignal' };

export function NightTicks({ win, everyMin = 120 }) {
  const { lang } = useI18n();
  const span = win.toMs - win.fromMs;
  const ticks = [];
  for (let ts = Math.ceil(win.fromMs / 3600000) * 3600000; ts <= win.toMs; ts += 3600000) {
    if (zonedParts(ts, win.tz).minutes % everyMin === 0) ticks.push(ts);
  }
  return (
    <div className="relative h-4 text-[10px] text-ink-muted font-mono" aria-hidden>
      {ticks.map((ts) => {
        const pct = ((ts - win.fromMs) / span) * 100;
        const pos = pct > 96 ? { right: 0 } : pct < 4 ? { left: 0 } : { left: `${pct}%`, transform: 'translateX(-50%)' };
        return <span key={ts} className="absolute" style={pos}>{fmtInTz(ts, win.tz, { hour: '2-digit', minute: '2-digit' }, lang)}</span>;
      })}
    </div>
  );
}

export const ResponsiveTicks = ({ win }) => (
  <>
    <div className="sm:hidden"><NightTicks win={win} everyMin={240} /></div>
    <div className="hidden sm:block"><NightTicks win={win} /></div>
  </>
);

// One night (window from nightWindow) in 5-min blocks, same colours as the 24 h DayBar.
export function NightBar({ buckets, ids, win, height = 'h-8', ticks = true, testid = 'night-bar' }) {
  const { t, lang } = useI18n();
  const segs = useMemo(() => segmentsBetween(buckets || [], ids, win.fromMs, win.toMs, 5), [buckets, ids, win]);
  const hm = (ms) => fmtInTz(ms, win.tz, { hour: '2-digit', minute: '2-digit' }, lang);
  return (
    <div data-testid={testid}>
      <div className={`flex w-full ${height} rounded-md overflow-hidden`}>
        {segs.map((s) => (
          <div key={s.ts} className="flex-1 min-w-0" style={{ background: s.kind === 'gap' ? HATCH : FILL[s.kind] }}
            title={`${hm(s.ts)}–${hm(s.ts + 300000)} · ${t(LABEL[s.kind])}`} data-kind={s.kind} />
        ))}
      </div>
      {ticks && <div className="mt-1"><ResponsiveTicks win={win} /></div>}
    </div>
  );
}
